import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  navigateWithTenant,
  resolveBootstrapTenantId,
  withTenantIdInPathname,
} from '@app-store'
import { RootState, useAppSelector } from '../../utils/agent.store'

export function TenantRootRedirect() {
  const location = useLocation()
  const navigateBase = useNavigate()
  const user = useAppSelector((s: RootState) => s.authUser.user)
  const selectedClient = useAppSelector(
    (s: RootState) => s.authUser.selectedClientTenant
  )

  // useEffect, NOT useLayoutEffect: on a cold load with an already-rehydrated
  // user (new tab) this redirect fires on the first commit. A child's layout
  // effect runs BEFORE RouterProvider subscribes to the router, so the
  // navigation updates the URL but React never re-renders — the URL gains the
  // tenant while the screen stays blank. Effects run after that subscription.
  useEffect(() => {
    if (!user) return
    const fromSlice = resolveBootstrapTenantId(user, selectedClient)
    navigateWithTenant(
      navigateBase,
      {
        pathname: withTenantIdInPathname(location.pathname, fromSlice),
        search: location.search,
        hash: location.hash,
      },
      { replace: true },
      fromSlice
    )
  }, [
    user,
    selectedClient?.id,
    location.pathname,
    location.search,
    location.hash,
    navigateBase,
  ])

  return null
}
